<template>
  <ConclusionStep
    data-testid="conclusion-step"
    class="conclusion-step"
    status="positive"
    :title="investmentConclusion.title"
    :description="investmentConclusion.subtitle"
    @close="goToProducts"
  >
    <main>
      <ContentDisplay content-aspect="outside" class="conclusion-step__content">
        <template #content-block-1>
          <Heading class="conclusion-step__product-name" :level="6">
            {{ investmentConclusion.productName }}
          </Heading>
          <ListDisplay
            v-for="(item, index) in investmentConclusion.investmentInfo"
            :key="index"
            class="conclusion-step__list-item"
            :title="item.label"
            :value="item.value"
          />
        </template>
      </ContentDisplay>
    </main>
    <template #button-primary>
      <ButtonPrimary
        label="Voltar para produtos"
        size="large"
        @click="goToProducts"
      />
    </template>
  </ConclusionStep>
</template>

<script setup lang="ts">
import { inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IInvestmentConclusion } from '@/modules/transaction/services/product-investment';

const route = useRoute();
const router = useRouter();

const investmentConclusion = inject(
  'investmentConclusion'
) as Ref<IInvestmentConclusion>;

function goToProducts() {
  router.push({
    name: 'productsCatalog',
    params: {
      type: route.params.type || 'fixed-income'
    }
  });
}
</script>

<style lang="less" scoped>
.conclusion-step {
  :deep(.flow-conclusion__content) {
    max-width: 492px;
  }

  :deep(.flow-conclusion__details) {
    align-items: initial;
  }

  &__content {
    margin-top: @size-spacing-x500;
    background-color: @background-tertiary;
    border: none;
    padding-bottom: @size-spacing-x500;
  }

  &__product-name {
    margin-bottom: @size-spacing-x500;
  }

  &__list-item {
    margin-bottom: @size-spacing-x350;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
